import React from "react";

const customDayCell = (props) => {
	return <div></div>;
};

export default customDayCell;
